import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";
import { TFormSchema, TGridSchema } from "@/comn/hooks";

/*
 * Notice Detail Service
 * !== 통보 상세 서비스 ==!
 */

export const BASE = {
    path: `${process.env.REACT_APP_BASE_COMN}/comn/dclr`,
    api: `${process.env.REACT_APP_API_PTLE}/api/v1/comn/comn/dclr`,
    nodes: [{ label: "Portal" }, { label: "Common Module" }, { label: "Notice Detail" }],
};

export const URLS = {
    ptli0409006s: `${BASE.path}/DclrDtl`, // Notice Detail Popup!== 통보_상세 팝업 ==! */
};

export const APIS = {
    // Electronic report processing status history list !== 전자신고서 처리현황 이력 목록 ==!
    getElecDclrPrcssSttsHistPpupList: (data: any) => {
        return api.get(`${BASE.api}/elec-dclr-prcss-stts-hist`, {
            params: comnUtils.toGetParams(data),
        });
    },

    // Electronic report processing status details !== 전자신고서 처리상태 상세 ==!
    getElecDclrPrcssSttsDtl: (dclrPrcssSttsUuid: any, prcssSrno: any) => {
        return api.get(`${BASE.api}/elec-dclr-prcss-stts-dtl/${dclrPrcssSttsUuid}/${prcssSrno}`);
    },

    // List of electronic report processing status errors !== 전자신고서 처리상태 오류 목록 ==!
    getElecDclrPrcssErrList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}/elec-dclr-prcss-stts-err?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // Electronic report processing status error details !== 전자신고서 처리상태 오류 상세 ==!
    getElecDclrPrcssErrDtl: (data: any) => {
        return api.get(`${BASE.api}/elec-dclr-prcss-stts-err-dtl`, {
            params: comnUtils.toGetParams(data),
        });
    },
};

export const SG_ELEC_DCLR_PRCSS_STTS_HIST_LIST: TGridSchema = {
    id: "grid_ElecDclrPrcssSttsHistList",
    options: { index: true, height: 200 },
    head: [
        { cells: [{ header: "L_DOC_SBMT_NO", binding: "docSbmtNo", width: 300 }] },
        { cells: [{ header: "L_AMD_DGR", binding: "amdDgr", width: 200 }] },
        { cells: [{ header: "L_PRCSS_STAT", binding: "prcssStatCdNm", width: 300 }] },
        { cells: [{ header: "L_DCLA_DTM", binding: "dclrPrcssDtm", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "docSbmtNo" }] },
        { cells: [{ binding: "amdDgr" }] },
        { cells: [{ binding: "prcssStatCdNm" }] },
        { cells: [{ binding: "dclrPrcssDtm" }] },
    ],
};

// /elec-dclr-prcss-stts-dtl
export const SF_ELEC_DCLR_PRCSS_STTS_INFO: TFormSchema = {
    id: "form_ElecDclrPrcssSttsInfo",
    schema: {
        cstmNm: { type: "text", label: "L_CSTM" },
        dclrPrcssDtm: { type: "text", label: "L_DCLA_DTM" },
        dclaDocCd: { type: "text", label: "L_DCLA_DOC_CD" },
        docNm: { type: "text", label: "L_DOC_NM" },
        prcssStatCdNm: { type: "text", label: "L_PRCSS_STAT" },
        docPrcssStatCdNm: { type: "text", label: "L_BSOP_PRCSS_STAT" },
        docSbmtNo: { type: "text", label: "L_DOC_SBMT_NO" },
        rmrk: { type: "textarea", label: "L_RTRN_RSN", controlSize: 10, rows: 5 },
        currCd: { type: "text", label: "L_CURR_CD" },
    },
};

export const SF_ELEC_DCLR_PRCSS_ERR_SRCH: TFormSchema = {
    id: "form_ElecDclrPrcssErrSrch",
    schema: {
        msgId: { type: "text", label: "msgId" },
    },
};

export const SG_ELEC_DCLR_PRCSS_ERR_LIST: TGridSchema = {
    id: "grid_ElecDclrPrcssErrList",
    options: { pagination: "out", index: true, height: 200 },
    head: [
        { cells: [{ header: "L_VALDN_TP", binding: "valdnTpCdNm", width: "*" }] },
        { cells: [{ header: "L_VALDN_ITM_LBL_NM", binding: "valdnItmNm", width: 200 }] },
        { cells: [{ header: "L_VALDN_ITM_VAL", binding: "valdnItmCn", width: 200 }] },
        { cells: [{ header: "L_ERR_NTC_DTM", binding: "dclrPrcssDtm", width: 300 }] },
    ],
    body: [
        { cells: [{ binding: "valdnTpCdNm", align: "left" }] },
        { cells: [{ binding: "valdnItmNm", align: "left" }] },
        {
            cells: [{ binding: "valdnItmCn" }],
        },
        {
            cells: [{ binding: "dclrPrcssDtm" }],
        },
    ],
};

export const SG_ELEC_DCLR_PRCSS_ERR_INFO: TFormSchema = {
    id: "form_ElecDclrPrcssErrInfo",
    schema: {
        cstmNm: { type: "text", label: "L_CSTM" },
        dclaDocCd: { type: "text", label: "L_DCLA_DOC_CD" },
        docNm: { type: "text", label: "L_DOC_NM" },
        dclrPrcssDtm: { type: "text", label: "L_DCLA_DTM" },
        docSbmtNo: { type: "text", label: "L_DOC_SBMT_NO" },
        valdnItmNm: { type: "text", label: "L_VALDN_ITM_LBL_NM" },
        valdnItmCn: { type: "text", label: "L_VALDN_ITM_VAL" },
        erkyCn1: { type: "text", label: "L_VALDN_KEY_1" },
        erkyCn2: { type: "text", label: "L_VALDN_KEY_2" },
        erkyCn3: { type: "text", label: "L_VALDN_KEY_3" },
        erkyCn4: { type: "text", label: "L_VALDN_KEY_4" },
        erkyCn5: { type: "text", label: "L_VALDN_KEY_5" },
        valdnTpCdNm: { type: "text", label: "L_VALDN_TP" },
        errMsgId: { type: "text", label: "L_ERR_MSG_CD" },
        errMsgCn: { type: "text", label: "L_ERR_MSG_CN" },
    },
};
